import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .map-wrapper {
    width: 100%;
  }

  .sub-header {
    display: flex;
    gap: 10px;
    margin-left: auto;
  }

  .map-container {
    width: 100%;
    height: 100%;
  }

  .widgets-container {
    display: flex;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;

    &>div:not(:first-child) {
      border-left: 1px solid ${(props) => props.theme.colors.outline};
    }
  }
`;

export default { Wrapper };
